import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import './BackOfficeMenuComponent.css'

export default class BackOfficeMenuComponent extends Component {
  render () {
    return (
      <div className="panel panel-menu">
        <ul className="list-group">
          <NavLink to={'/backoffice/users'} className="list-group-item menu-item" activeClassName={'active'}>Utenti</NavLink>
          <NavLink to={'/backoffice/vehicles'} className="list-group-item menu-item" activeClassName={'active'}>Veicoli</NavLink>
          <NavLink to={'/backoffice/marks'} className="list-group-item menu-item" activeClassName={'active'}>Contrassegni</NavLink>
          {/* <NavLink to={"/backoffice/parkingPasses"} className="list-group-item menu-item" activeClassName={"active"}>Abbonamenti</NavLink> */}
          <NavLink to={'/backoffice/receipts'} className="list-group-item menu-item" activeClassName={'active'}>Ricevute</NavLink>
          <NavLink to={'/backoffice/waiting-lists'} className="list-group-item menu-item" activeClassName={'active'}>Liste d'attesa</NavLink>
          <NavLink to={'/backoffice/reports'} className="list-group-item menu-item" activeClassName={'active'}>Reports</NavLink>
          <NavLink to={'/backoffice/settings'} className="list-group-item menu-item" activeClassName={'active'}>Impostazioni</NavLink>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BackOfficeMenuComponent.js